import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=0e21712b&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=ts&"
export * from "./Tasks.vue?vue&type=script&lang=ts&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=0e21712b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e21712b",
  null
  
)

export default component.exports